import { server } from '@/helpers';
import { useAppDispatch } from '@/hooks';
import { serviceActions } from '@/actions/serviceActions';

const useService = () => {
  const reduxDispatch = useAppDispatch();

  async function fetchService(serviceId: number) {
    const result = await server.request
      .get(`/reviews/v2/service`, { params: { serviceId } })
      .then(server.handleSuccess)
      .catch(server.handleError);
    const payload = {
      ids: [serviceId],
      all: {
        [serviceId]: result.service,
      },
    };
    reduxDispatch(serviceActions.setServices(payload));

    return result;
  }

  return {
    loadService: (serviceId: number) => {
      return fetchService(serviceId);
    },
  };

  // Implement the hook logic here
};

export default useService;
